const getCustomStyles = (hasError: boolean) => ({
    clearIndicator: (provided: any) => ({
        ...provided,
        cursor: 'pointer',
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        border: hasError ? '2px solid red' : '1px solid #E2E8F0',
        boxShadow: 'none',
        '&:hover': {
            borderColor: hasError ? 'red' : 'blue',
        },
        borderRadius: '0.375rem',
        backgroundColor: state.isDisabled ? 'white' : 'initial'
    }),
});

export {
    getCustomStyles
}